import { FC } from 'react';
import { Translate } from '~/i18n';
import React from 'react';
import cn from 'classnames';
import { formatNumber } from '~/utils/format-price';
interface VoucherCardProps {
   amount: number;
   custom_background: any;
   code?: any;
   isSmall?: boolean;
}

/**
 * This component create a reponsive voucher card
 */

const VoucherCard: FC<VoucherCardProps> = ({
   children,
   amount,
   custom_background,
   code,
   isSmall,
}) => {
   return (
      <div className="py-5">
         <div className="container bg-white shadow-md rounded-2xl">
            <div
               style={{
                  backgroundImage: `url(${
                     custom_background?.src || custom_background || '/images/not_found.svg'
                  })`,
               }}
               className="relative w-auto h-auto bg-center bg-no-repeat bg-cover rounded-lg">
               <div>
                  <div className="inline-block text-white ">
                     <div
                        className={cn(
                           'font-bold ',
                           isSmall
                              ? 'text-xs rtl:pr-2 ltr:pl-2 pt-2'
                              : 'text-xl rtl:pr-4 ltr:pl-4 pt-5'
                        )}>
                        {code}
                     </div>
                  </div>
                  <div
                     className={cn(
                        'text-white inline-block font-bold absolute ltr:right-0 rtl:left-0 ',
                        isSmall
                           ? 'text-xs ltr:pr-2 rtl:pl-2 pt-2'
                           : 'text-xl ltr:pr-4 rtl:pl-4 pt-5'
                     )}>
                     <div className="pt-0.5 inline">
                        <Translate
                           parseHTML
                           id="common:price"
                           values={{
                              amount: formatNumber(amount),
                           }}
                        />
                     </div>
                  </div>
               </div>
               {children}
            </div>
         </div>
      </div>
   );
};
export default VoucherCard;
